import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, modelFunctionsState } from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { deleteModelFunction } from "../../../api/delete-model-function";

type Props = {
  id: Id;
  onSuccess: () => void;
};

export const DeleteModelFunction: FC<Props> = (props) => {
  const { id, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setModelFunctions = useSetRecoilState(modelFunctionsState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        deleteModelFunction({ id, subscriptionId: activeSubscriptionId as Id }),
    },

    actions: {
      success: (_, event: any) => {
        setModelFunctions(event.data.modelFunctions);
        onSuccess();
        toast({
          title: "modelfunctie verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van modelfunctie niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
